"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GleamMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _typographyMixin = require("../typographyMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance,
    inverse = props.inverse;
  var backgroundThemePath = inverse ? "Gleam." + appearance + ".inverse.backgroundColor" : "Gleam." + appearance + ".backgroundColor";
  var foregroundThemePath = inverse ? "Gleam." + appearance + ".inverse.fontColor" : "Gleam." + appearance + ".fontColor";
  return (0, _styledToken.default)({
    background: backgroundThemePath,
    color: foregroundThemePath
  }, function (_ref) {
    var background = _ref.background,
      color = _ref.color;
    return (0, _styledComponents.css)(["background:", ";color:", ";"], background, color);
  })(props);
};

/** @class GleamMixin */
/** @method */
var GleamMixin = function GleamMixin(props) {
  return (0, _styledToken.default)({
    fontType: 'Gleam.fontType',
    borderRadius: 'Gleam.borderRadius',
    height: 'Gleam.height',
    padding: 'Gleam.padding'
  }, function (_ref2) {
    var fontType = _ref2.fontType,
      borderRadius = _ref2.borderRadius,
      height = _ref2.height,
      padding = _ref2.padding;
    return (0, _styledComponents.css)(["", " display:inline-block;border-radius:", ";height:", "px;line-height:", "px;padding-left:", "px;padding-right:", "px;", ""], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType
    }, props)), borderRadius, height, height, padding, padding, appearanceCSS(props));
  })(props);
};
exports.GleamMixin = GleamMixin;